// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LlCU","footer":"styles_footer__3y4Pb"};